//
// Common JS for all the pages
// --------------------------------------------------

import "lazysizes";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";
import * as basicLightbox from "basiclightbox";
import { socialSharing } from "./common/sharing";
import "@cmyee/pushy/js/pushy";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	// Socials
	if (document.querySelector(".social-share")) {
		const fb = new socialSharing(
			document.querySelector(".social-share .social-facebook-share"),
			{ kind: "facebook" },
		);
		const x = new socialSharing(
			document.querySelector(".social-share .social-X-share"),
			{ kind: "x", suffix: "via @movieplayer_it" },
		);
		const tg = new socialSharing(
			document.querySelector(".social-share .social-telegram-share"),
			{ kind: "telegram" },
		);
		const wa = new socialSharing(
			document.querySelector(".social-share .social-whatsapp-share"),
			{ kind: "whatsapp" },
		);
	}

	// Search
	document.querySelector("#btn-search")?.addEventListener("click", (event) => {
		window.location.href = event.target.dataset.url;
	});

	// Form errors
	if (document.querySelector(".errorlist")) {
		scroll({
			top: document.querySelector("form").offsetTop,
			behavior: "smooth",
		});
	}

	// Tos lightbox
	document.querySelector("#_tos")?.addEventListener("click", (event) => {
		event.preventDefault();
		const tosLightbox = basicLightbox.create(
			`<iframe width="90%" height="70%" src="https://www.iubenda.com/privacy-policy/106302" title="Privacy Policy" frameborder="0" allowfullscreen></iframe>`,
		);
		tosLightbox.show();
	});
});
